"use strict";
/**
 * Home's words (Anthony's Home spec, 2026-10-13; reports 133 and 136), shared by both
 * apps' Home under rule 17. Verbatim from web's Home components on develop (d4c874f9);
 * web moves onto these keys in a follow-up and deletes its frontend/src/lib/homeCopy.ts.
 *
 * Helpers take preformatted dates and currency, so each app keeps its own formatting.
 * "Payday" and "Paychecks before payday" are constants on purpose: which paycheck
 * counts as payday with two in a period is open (report 139), and a rename must be
 * one line.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOME_START_ACTION_COPY = exports.HOME_MAKE_BUCKETS_TITLE_COPY = exports.HOME_SEE_PURCHASES_COPY = exports.HOME_REMAINING_TITLE_COPY = exports.HOME_SAFE_TO_SPEND_SUB_COPY = exports.HOME_INCLUDES_PENDING_COPY = exports.HOME_TRY_AGAIN_COPY = exports.HOME_LOAD_ERROR_COPY = exports.HOME_RECONNECT_COPY = exports.HOME_MAY_BE_OUT_OF_DATE_COPY = exports.HOME_PENDING_COPY = exports.HOME_NO_PURCHASES_COPY = exports.HOME_ALL_ACTIVITY_COPY = exports.HOME_LATEST_TITLE_COPY = exports.HOME_NO_PAYOFF_DATE_COPY = exports.HOME_OWED_COPY = exports.HOME_DEBT_COPY = exports.HOME_BEHIND_COPY = exports.HOME_ON_TRACK_COPY = exports.HOME_SET_A_GOAL_COPY = exports.HOME_NO_GOALS_OR_DEBTS_COPY = exports.HOME_GOALS_DEBT_TITLE_COPY = exports.HOME_TILE_PERIOD_ENDS_COPY = exports.HOME_TILE_PROJECTED_COPY = exports.HOME_TILE_PAYCHECKS_COPY = exports.HOME_TILE_BILLS_DUE_COPY = exports.HOME_TILE_BALANCE_TODAY_COPY = exports.HOME_BALANCE_COPY = exports.HOME_PERIOD_ENDS_COPY = exports.HOME_PAYDAY_COPY = exports.HOME_TODAY_COPY = exports.HOME_OPEN_CALENDAR_COPY = exports.HOME_LEGEND_PROJECTED_COPY = exports.HOME_LEGEND_PAYCHECK_COPY = exports.HOME_LEGEND_BILLS_COPY = exports.HOME_TIMELINE_SUBTITLE_COPY = exports.HOME_TIMELINE_TITLE_COPY = exports.HOME_FOUND_DEBTS_HINT_COPY = exports.HOME_REVIEW_ACTION_COPY = exports.HOME_SORT_ACTION_COPY = exports.HOME_WHICH_CATEGORY_COPY = exports.HOME_NEEDS_ATTENTION_TITLE_COPY = exports.HOME_CHECKLIST_DISMISS_COPY = exports.HOME_CHECKLIST_GOAL_COPY = exports.HOME_CHECKLIST_SORT_COPY = exports.HOME_CHECKLIST_TITLE_COPY = exports.HOME_SINCE_LAST_VISIT_LABEL_COPY = exports.HOME_NEXT_30_DAYS_COPY = exports.HOME_REFRESH_LABEL_COPY = exports.HOME_UPDATING_COPY = void 0;
exports.HOME_DEBT_MENU_OPEN_SUB_COPY = exports.HOME_DEBT_MENU_OPEN_COPY = exports.HOME_DEBT_MENU_CHANGE_COPY = exports.HOME_DEBT_MENU_PROMPT_COPY = exports.HOME_DEBT_CARD_CTA_COPY = exports.HOME_CHANGE_IT_COPY = exports.HOME_SET_A_TARGET_COPY = exports.HOME_EACH_PAYCHECK_COPY = exports.HOME_TAG_GOAL_COPY = exports.HOME_TAG_SAVINGS_COPY = exports.HOME_TILE_BALANCE_AT_PERIOD_END_COPY = exports.HOME_OPEN_ACTION_COPY = exports.HOME_DONE_ACTION_COPY = exports.HOME_MOVE_TO_SAVINGS_COPY = exports.HOME_WHAT_WAS_THIS_FOR_COPY = exports.HOME_PLAN_ACTION_COPY = exports.HOME_DEBTS_LOANS_TITLE_COPY = void 0;
exports.homePeriodLabel = homePeriodLabel;
exports.sinceLastVisitLine = sinceLastVisitLine;
exports.foundDebtsCopy = foundDebtsCopy;
exports.seeAllToSortCopy = seeAllToSortCopy;
exports.paidOffByCopy = paidOffByCopy;
exports.moreInPlanCopy = moreInPlanCopy;
exports.setAsideEachPaycheckCopy = setAsideEachPaycheckCopy;
exports.neededPaceCopy = neededPaceCopy;
exports.targetDateCopy = targetDateCopy;
exports.ofTargetCopy = ofTargetCopy;
exports.numbersAreFromCopy = numbersAreFromCopy;
exports.homePlanIsSetCopy = homePlanIsSetCopy;
exports.homeDaysToPaydayCopy = homeDaysToPaydayCopy;
exports.homePaydayLinkCopy = homePaydayLinkCopy;
exports.homeSpentOfCopy = homeSpentOfCopy;
exports.homeAboutADayCopy = homeAboutADayCopy;
exports.homeRemainingSubCopy = homeRemainingSubCopy;
exports.homeUsualListCopy = homeUsualListCopy;
exports.homeDebtCountsCopy = homeDebtCountsCopy;
exports.homeDebtsFoundSubCopy = homeDebtsFoundSubCopy;
exports.homeOverByTitleCopy = homeOverByTitleCopy;
exports.homeCoveredRaiseCopy = homeCoveredRaiseCopy;
exports.homeNotMovedTitleCopy = homeNotMovedTitleCopy;
exports.homeLeftCopy = homeLeftCopy;
exports.homeOverByCopy = homeOverByCopy;
exports.homeSpentOfPlannedCopy = homeSpentOfPlannedCopy;
exports.homeCoveredFromLineCopy = homeCoveredFromLineCopy;
exports.homeCoveredForLineCopy = homeCoveredForLineCopy;
exports.homeStartedNoTargetCopy = homeStartedNoTargetCopy;
exports.homeLeftOnCopy = homeLeftOnCopy;
exports.homeDebtPlanLineCopy = homeDebtPlanLineCopy;
exports.homeDebtMenuChangeSubCopy = homeDebtMenuChangeSubCopy;
exports.homeNoGoalsCopy = homeNoGoalsCopy;
// ── Header ──────────────────────────────────────────────────────────────────────────
exports.HOME_UPDATING_COPY = "Updating…";
exports.HOME_REFRESH_LABEL_COPY = "Refresh bank data";
/** With no paycheck detected there is no pay period: a forward look instead. */
exports.HOME_NEXT_30_DAYS_COPY = "Next 30 days";
function homePeriodLabel(start, end) {
    return `Pay period ${start} – ${end}`;
}
// ── Since your last visit (HP-21) and the first-week checklist (RD-32) ──────────────
exports.HOME_SINCE_LAST_VISIT_LABEL_COPY = "Since your last visit";
exports.HOME_CHECKLIST_TITLE_COPY = "Your first week";
exports.HOME_CHECKLIST_SORT_COPY = "Sort the purchases we couldn't place";
exports.HOME_CHECKLIST_GOAL_COPY = "Add a goal (optional)";
exports.HOME_CHECKLIST_DISMISS_COPY = "Dismiss";
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
/** "6 new purchases · $142 spent · Mobile bill paid", the spec's own example's shape.
 *  `formatWholeDollars` formats the rounded amount spent (each app's own formatter). */
function sinceLastVisitLine(visit, formatWholeDollars) {
    const parts = [];
    const bills = visit.bills_paid ?? visit.billsPaid ?? [];
    if (visit.purchases > 0) {
        parts.push(plural(visit.purchases, "new purchase", "new purchases"));
        parts.push(`${formatWholeDollars(Math.round(Number(visit.spent)))} spent`);
    }
    // Up to two bills by name, as the example; more than that is a count, so the line
    // stays one line.
    if (bills.length > 2)
        parts.push(`${bills.length} bills paid`);
    else
        for (const bill of bills)
            parts.push(`${bill} paid`);
    return parts.join(" · ");
}
// ── Needs your attention (HP-05 / 06 / 08) ──────────────────────────────────────────
exports.HOME_NEEDS_ATTENTION_TITLE_COPY = "Needs your attention";
exports.HOME_WHICH_CATEGORY_COPY = "Which category is this?";
exports.HOME_SORT_ACTION_COPY = "Sort";
exports.HOME_REVIEW_ACTION_COPY = "Review";
exports.HOME_FOUND_DEBTS_HINT_COPY = "Add them to your plan or dismiss them.";
function foundDebtsCopy(count) {
    return `We found ${count} ${count === 1 ? "debt" : "debts"}`;
}
function seeAllToSortCopy(count) {
    return `See all ${count} to sort`;
}
// ── Your transaction timeline (HP-12 / 13 / 14) ─────────────────────────────────────
exports.HOME_TIMELINE_TITLE_COPY = "Your transaction timeline";
exports.HOME_TIMELINE_SUBTITLE_COPY = "What's coming in and going out until payday, and your balance after each one.";
exports.HOME_LEGEND_BILLS_COPY = "Bills";
exports.HOME_LEGEND_PAYCHECK_COPY = "Paycheck";
exports.HOME_LEGEND_PROJECTED_COPY = "Projected balance";
exports.HOME_OPEN_CALENDAR_COPY = "Open calendar";
exports.HOME_TODAY_COPY = "Today";
exports.HOME_PAYDAY_COPY = "Payday";
exports.HOME_PERIOD_ENDS_COPY = "Period ends";
exports.HOME_BALANCE_COPY = "Balance";
exports.HOME_TILE_BALANCE_TODAY_COPY = "Balance today";
/** Anthony's Home board's words (2026-10-29; was "Bills due before payday"). Upcoming's
 *  before-payday heading prints this same string (CALL-06 decision 4). */
exports.HOME_TILE_BILLS_DUE_COPY = "Bills before payday";
exports.HOME_TILE_PAYCHECKS_COPY = "Paychecks before payday";
/** Forecast's own words for the period-end figure, exactly (its timeline's last marker). */
exports.HOME_TILE_PROJECTED_COPY = "Projected Balance";
exports.HOME_TILE_PERIOD_ENDS_COPY = "Period Ends";
// ── Goals & debt (HP-17) ─────────────────────────────────────────────────────────────
exports.HOME_GOALS_DEBT_TITLE_COPY = "Goals & debt";
exports.HOME_NO_GOALS_OR_DEBTS_COPY = "No goals or debts yet.";
exports.HOME_SET_A_GOAL_COPY = "Set a goal in Plan";
exports.HOME_ON_TRACK_COPY = "On track";
exports.HOME_BEHIND_COPY = "Behind";
exports.HOME_DEBT_COPY = "Debt";
exports.HOME_OWED_COPY = "owed";
exports.HOME_NO_PAYOFF_DATE_COPY = "No payoff date yet";
function paidOffByCopy(date) {
    return `Paid off by ${date} on your plan`;
}
function moreInPlanCopy(count) {
    return `${count} more in Plan`;
}
function setAsideEachPaycheckCopy(amount) {
    return `${amount} set aside each paycheck`;
}
function neededPaceCopy(amount, date) {
    return `Needs ${amount} a month to reach it by ${date}`;
}
function targetDateCopy(date) {
    return `Target ${date}`;
}
function ofTargetCopy(amount) {
    return `of ${amount}`;
}
// ── Latest (HP-18 / 19) ──────────────────────────────────────────────────────────────
exports.HOME_LATEST_TITLE_COPY = "Latest";
exports.HOME_ALL_ACTIVITY_COPY = "All activity";
exports.HOME_NO_PURCHASES_COPY = "No purchases yet this period.";
exports.HOME_PENDING_COPY = "pending";
// ── Bank unreachable (HP-24) and errors ─────────────────────────────────────────────
function numbersAreFromCopy(when) {
    return `Numbers are from ${when}.`;
}
exports.HOME_MAY_BE_OUT_OF_DATE_COPY = "These numbers may be out of date.";
exports.HOME_RECONNECT_COPY = "Reconnect";
exports.HOME_LOAD_ERROR_COPY = "Couldn't load Home. Nothing has changed.";
exports.HOME_TRY_AGAIN_COPY = "Try again";
// ── Anthony's Home board (Plan Page · Home.dc.html, 2026-10-29) ─────────────────────
// Every state: planned · justConfirmed · overspent · noBuckets · debtChoice. Words
// exactly as the board's; each figure is the server's (helpers take them formatted).
/** The header's freshness line: "Updated 2 hours ago · includes pending". */
exports.HOME_INCLUDES_PENDING_COPY = "includes pending";
/** justConfirmed: the banner's bold lead; HOME_INTRO_BANNER follows, then "Got it". */
function homePlanIsSetCopy(buckets) {
    return `Your plan is set: ${plural(buckets, "bucket", "buckets")}.`;
}
// Hero (planned and overspent: Safe to spend; noBuckets: Remaining balance).
exports.HOME_SAFE_TO_SPEND_SUB_COPY = "What's left in your Splash Fund. Bills, groceries, transportation, savings and debt payoff are already set aside.";
function homeDaysToPaydayCopy(days) {
    return days === 1 ? "day to payday" : "days to payday";
}
/** The payday link: "Mon, Oct 26 · $3,800". */
function homePaydayLinkCopy(date, amount) {
    return amount === null ? date : `${date} · ${amount}`;
}
function homeSpentOfCopy(spent, total) {
    return `${spent} spent of ${total}`;
}
/** "About $30 a day": the server's figure, already rounded down. */
function homeAboutADayCopy(amount) {
    return `About ${amount} a day`;
}
exports.HOME_REMAINING_TITLE_COPY = "Remaining balance until payday";
function homeRemainingSubCopy(balance, bills) {
    return `Your ${balance} balance minus ${bills} in bills before payday. Nothing is set aside yet, so groceries and gas come out of this too.`;
}
exports.HOME_SEE_PURCHASES_COPY = "See purchases";
// Needs your attention.
exports.HOME_MAKE_BUCKETS_TITLE_COPY = "Make your spending into buckets";
/** "Groceries $284, Splash Fund $512, Transportation $86". */
function homeUsualListCopy(parts) {
    return parts.map((p) => `${p.name} ${p.amount}`).join(", ");
}
exports.HOME_START_ACTION_COPY = "Start";
exports.HOME_DEBTS_LOANS_TITLE_COPY = "Debts & loans";
/** "2 credit cards and 2 loans", "1 credit card", "3 loans". */
function homeDebtCountsCopy(cards, loans) {
    const parts = [
        cards > 0 ? plural(cards, "credit card", "credit cards") : null,
        loans > 0 ? plural(loans, "loan", "loans") : null,
    ].filter((p) => p !== null);
    return parts.join(" and ");
}
/**
 * The Nov 3 Plan spec's Home "Needs attention" line (03-plan-page-spec-nov-3.md, the link
 * table): "We found 2 credit cards and 2 loans. Plan to pay them down?". It replaced
 * "Plan Debt payoff?", the old name (Paul, 2026-11-04). One debt reads "pay it down".
 */
function homeDebtsFoundSubCopy(cards, loans) {
    const one = cards + loans === 1;
    return `We found ${homeDebtCountsCopy(cards, loans)}. Plan to pay ${one ? "it" : "them"} down?`;
}
exports.HOME_PLAN_ACTION_COPY = "Plan";
exports.HOME_WHAT_WAS_THIS_FOR_COPY = "What was this for?";
function homeOverByTitleCopy(name, amount) {
    return `${name} over by ${amount}`;
}
function homeCoveredRaiseCopy(from, name) {
    return `Covered from ${from}. Raise ${name} next period?`;
}
function homeNotMovedTitleCopy(name, amount) {
    return `${name} · ${amount} not moved yet`;
}
exports.HOME_MOVE_TO_SAVINGS_COPY = "Move it to savings in your bank app";
exports.HOME_DONE_ACTION_COPY = "Done";
/** A row the board doesn't draw (the check-in, money not planned yet): open it on Plan. */
exports.HOME_OPEN_ACTION_COPY = "Open";
// Your transaction timeline: the summary's last tile, in the board's words (the figure
// is still Forecast's period-end marker).
exports.HOME_TILE_BALANCE_AT_PERIOD_END_COPY = "Balance at period end";
// This pay period.
function homeLeftCopy(amount) {
    return `${amount} left`;
}
function homeOverByCopy(amount) {
    return `Over by ${amount}`;
}
function homeSpentOfPlannedCopy(spent, total) {
    return `${spent} of ${total} spent`;
}
function homeCoveredFromLineCopy(spent, total, from) {
    return `${spent} of ${total} · covered from ${from}`;
}
/** The bucket that covered another: "$0 of $800 spent · $40 to cover Groceries". The
 *  board's "incl. $40 for Groceries" counts the $40 in what was spent; Plan's spent
 *  doesn't (Needs Paul), so the line says it beside it. */
function homeCoveredForLineCopy(spent, total, amount, name) {
    return `${spent} of ${total} spent · ${amount} to cover ${name}`;
}
// Goals & debt.
exports.HOME_TAG_SAVINGS_COPY = "Savings";
exports.HOME_TAG_GOAL_COPY = "Goal";
exports.HOME_EACH_PAYCHECK_COPY = "each paycheck";
function homeStartedNoTargetCopy(date) {
    return `Started ${date} · no target yet`;
}
exports.HOME_SET_A_TARGET_COPY = "Set a target";
exports.HOME_CHANGE_IT_COPY = "Change it";
/** The Debt payoff card's note: "left on 2 cards". */
function homeLeftOnCopy(what) {
    return `left on ${what}`;
}
/** "$300 extra each paycheck · Store card first · debt-free May 2027"; a part the plan
 *  doesn't know yet is left out. */
function homeDebtPlanLineCopy(extra, nowPaying, debtFree) {
    return [
        `${extra} extra each paycheck`,
        nowPaying ? `${nowPaying} first` : null,
        debtFree ? `debt-free ${debtFree}` : null,
    ]
        .filter((p) => p !== null)
        .join(" · ");
}
exports.HOME_DEBT_CARD_CTA_COPY = "Change amount or see payoff plan";
exports.HOME_DEBT_MENU_PROMPT_COPY = "What would you like to do?";
exports.HOME_DEBT_MENU_CHANGE_COPY = "Change the extra amount";
function homeDebtMenuChangeSubCopy(extra) {
    return `Opens Plan on Debt payoff · now ${extra} each paycheck`;
}
/** The page is Debt Eliminator (Debt Eliminator Spec 1.2 §4.1; Paul, 2026-10-31). The
 *  board said "Open Debt payoff"; the card and its bucket keep the name Debt payoff. */
exports.HOME_DEBT_MENU_OPEN_COPY = "Open Debt Eliminator";
exports.HOME_DEBT_MENU_OPEN_SUB_COPY = "Your debts and loans, payoff order and debt-free date";
/** noBuckets (and a plan with nothing set aside): "No goals yet. …". */
function homeNoGoalsCopy(cards, loans) {
    const found = cards + loans > 0
        ? ` We found payments on ${homeDebtCountsCopy(cards, loans)}.`
        : "";
    return `No goals yet.${found} You can plan Debt payoff, an emergency fund and goals on Plan.`;
}
//# sourceMappingURL=homeCopy.js.map